import { TextField } from "@material-ui/core";
import { CloseIcon, MagnifyingGlassIcon } from "../../../assets";
import React, { FormEvent, useEffect, useState } from "react";

type FilterByHeaderProps = {
  headerText: string;
  onFilter: (value: string | undefined) => void;
};

export const FilterByDate = ({
  headerText,
  onFilter,
}: FilterByHeaderProps): React.ReactElement => {
  const [value, setValue] = useState<string | undefined>(undefined);
  const [openInput, setOpenInput] = useState(false);

  const handleChange = (newData: string | undefined): void => {
    setValue(newData);
  };

  const handleSubmit = (e: FormEvent): void => {
    e.preventDefault();
    onFilter(value);
  };

  useEffect(() => {
    setValue(undefined);
  }, [openInput]);

  useEffect(() => {
    onFilter(value);
  }, [onFilter, value]);

  return (
    <section className="relative">
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <section
        onClick={() => {
          setOpenInput(true);
        }}
        className="flex flex-row items-center justify-center"
      >
        <span className="mr-[10px] text-[11px]">{headerText}</span>
        <section className="h-[14px] w-[14px] items-center justify-center">
          <MagnifyingGlassIcon fill="#147EFB" />
        </section>
      </section>

      {openInput && (
        <form
          onSubmit={handleSubmit}
          className="absolute top-0 left-0 flex h-full w-full  max-w-[110px] items-center justify-between rounded-[5px] bg-[#FFFFFF] py-1 pl-2 pr-1 shadow-[2px_2px_2px_rgba(0,0,0,0.15)]"
        >
          <TextField
            InputProps={{ disableUnderline: true }}
            id="date"
            type="date"
            className="w-16 cursor-text p-0"
            defaultValue={value}
            onFocus={(event) => {
              event.target.select();
            }}
            inputProps={{
              className:
                "text-[11px] font-bold mr-1 min-w-[70px] p-0 truncate text-black input-icon-none relative w-[70px] flex items-center pt-[2px]",
            }}
            onChange={(e) => handleChange(e.target.value)}
          />
          <div className="flex items-center">
            <button
              onClick={() => {
                handleChange(undefined);
                onFilter(undefined);
                setOpenInput(false);
              }}
            >
              <CloseIcon
                className="text-sm text-[#147EFB]"
                width={18}
                height={18}
              />
            </button>
          </div>
        </form>
      )}
    </section>
  );
};
